<template>
  <footer>
    <div class="footer-content">
      <logo color="white" :small="true">LendingWell</logo>

      <div>
        <p>{{ contact.addressLine1 }}<br />{{ contact.addressLine2 }}</p>
        <p>
          {{ contact.email }}
        </p>
        <p>{{ contact.phone }}</p>
      </div>

      <div>
        <router-link
          v-for="link in legalLinks"
          :key="link.text"
          :to="link.to"
          class="default-btn small text"
        >
          {{ link.text }}
        </router-link>
      </div>

      <div class="social-links-wrapper">
        <a
          v-for="social in socialLinks"
          :key="'link-' + social.link"
          :href="social.link"
          class="default-btn text"
          target="_blank"

        >
          <v-icon v-if="social.icon">{{ social.icon }}</v-icon>
          <img v-if="social.img" :src="social.img" />
        </a>
      </div>

      <p class="disclaimer">
        The operator of this website is NOT a lender, does not make offers for loans, does not broker online loans to lenders or lending partners, and does not assist you in obtaining a loan. Customers who arrive at www.lending-well.com are paired with a lender or a lending partner, and redirected only to lenders or lending partners who offer business loan products.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    contact: {
      addressLine1: '12570 SW 69th Ave',
      addressLine2: 'Portland OR 97223',
      email: 'info@lending-well.com',
      phone: '(503) 404-3398',
    },
    socialLinks: [
      { icon: 'mdi-facebook-box', link: 'https://www.facebook.com/LendingWell1/' },
      { icon: 'mdi-twitter-box', link: 'https://twitter.com/lending_well' },
      { icon: 'mdi-linkedin-box', link: 'https://www.linkedin.com/company/lendingwell' },
    ],
    legalLinks: [
      { text: 'Terms and Conditions', to: { name: 'TermsAndConditions' } },
    ],
  }),
}
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  padding: 80px 0;

  background-color: #383838;
  color: white;
  font-family: "Sansation Regular", sans-serif;
  text-align: center;

  p {
    color: white !important;
  }

  .footer-content {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    .default-btn.text {
      color: white !important;
      font-family: "Avenir Medium", sans-serif;
      margin: 0 30px;
    }
  }

  .social-links-wrapper {
    display: flex;
    order: 1;

    .default-btn.text {
      margin: 0 10px;
      padding: 5px;
      color: #8E8E8E !important;
    }

    i {
      font-size: 28px;
    }

    img {
      width: 25px;
      height: 25px;
    }
  }

  .social-links a {
    margin-top: 5px;
    margin-right: 5px;
  }

  .disclaimer {
    width: 100%;

    margin-top: 30px;
    font-family: "Avenir Medium", sans-serif;
    font-size: 14px;

    @include lg { margin-bottom: 0; }
  }

  .logo-container {
    margin-bottom: 20px;
    height: auto !important;
  }

  @include lg {
    align-items: stretch;
    text-align: left;

    .footer-content {
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;

      .logo-container {
        width: 100%;
      }
    }

    .social-links-wrapper {
      order: 0;
      margin-left: auto;
    }
  }
}

</style>
